import { ThreeDotsMenuItem } from '@core/components/helpers/navigation/three-dots-menu/three-dots-menu-item';

export const FieldsStandardRemoveMenuItem: Array<ThreeDotsMenuItem> = [
    // /*NOT SURE THIS IS NEEDED*/
    // {
    //     title: "Edit",
    //     key: "edit",
    //     icon: "edit",
    //     order: 12
    // }, 
    {
        title: "Remove",
        key: "confirmation-remove", // important to have the remove behavoiour
        icon: "remove",
        order: 15
    }

];

export const FieldsMenuMoveUp: ThreeDotsMenuItem =  {
    title: "Move up",
    key: "move-up",
    icon: "upload",//"move-up",
    order: 10
};

export const FieldsMenuMoveDown: ThreeDotsMenuItem =  {
    title: "Move down",
    key: "move-down",
    icon: "download",//"move-down",
    order: 11
};

export const FieldsMenuReallyRemove: ThreeDotsMenuItem =  {
    title: "Really",
    key: "really-remove",
    icon: "remove really",
    order: 20
};